module.exports = __webpack_public_path__ + "img/commissioned_unscanned.0deac6e5.png";